import { render, staticRenderFns } from "./FormDistribuicao.vue?vue&type=template&id=7a731d14"
import script from "./FormDistribuicao.vue?vue&type=script&lang=js"
export * from "./FormDistribuicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports